import { imageOptimize } from '@utils/images'
import { useMemo } from 'react'
import { ImageOptimizerParams } from 'types/utils'

export function useOptimizedImage(
  src?: string,
  { q = '50', dpr = '1', fm = 'webp', ...ioProps }: ImageOptimizerParams = {}
) {
  return useMemo(() => {
    return imageOptimize(src, { q, dpr, fm, ...ioProps })
  }, [dpr, fm, ioProps, q, src])
}
